import api from "../utils/axiosInstance";
import {
    GET_TRANSACTION_HISTORY_REQUEST,
    GET_TRANSACTION_HISTORY_SUCCESS,
    GET_TRANSACTION_HISTORY_FAILURE,
    RESET_TRANSACTION_HISTORY
} from "../ActionTypes/ActionTypes";

/* ---------------- REQUEST ---------------- */
const getTransactionHistoryRequest = () => ({
    type: GET_TRANSACTION_HISTORY_REQUEST
});

/* ---------------- SUCCESS ---------------- */
const getTransactionHistorySuccess = ({ list, pagination, totals, query }) => ({
    type: GET_TRANSACTION_HISTORY_SUCCESS,
    payload: {
        list,
        pagination,
        totals,
        query
    }
});

/* ---------------- FAILURE ---------------- */
const getTransactionHistoryFailure = (error) => ({
    type: GET_TRANSACTION_HISTORY_FAILURE,
    payload: error
});

/* ---------------- API ACTION ---------------- */
export const getTransactionHistory = (payload) => async (dispatch) => {
    dispatch(getTransactionHistoryRequest());

    try {
        const { data } = await api.post("/wallet/getTransaction-history", payload);

        if (data?.success) {
            dispatch(getTransactionHistorySuccess({
                list: data.result.docs,
                pagination: { totalPages: data?.result?.totalPages },
                totals: data?.result?.totalCount,
                query: payload
            })
            );
        } else {
            dispatch(getTransactionHistoryFailure(data?.message || "Failed to fetch transactions"));
        }
    } catch (error) {
        dispatch(getTransactionHistoryFailure(error.response?.data?.message || error.message));
    }
};

/* ---------------- RESET ---------------- */
export const resetTransactionHistory = () => ({
    type: RESET_TRANSACTION_HISTORY
});